import React from "react";
import { EpgCategoriesWrapper, CategoriesIconStyled, CategoriesLabelStyled } from "./styles/Styled";

class EpgCategoriesHeader extends React.Component {
  render() {
    const { label, icon } = (this.props && this.props.heading) || {};
    return (
      <EpgCategoriesWrapper>
        <CategoriesIconStyled data={icon.svg} width="28.5" height="28.5">
          {" "}
        </CategoriesIconStyled>
        <CategoriesLabelStyled>{label}</CategoriesLabelStyled>
      </EpgCategoriesWrapper>
    );
  }
}

export default EpgCategoriesHeader;
